var map = {
	"./mighty-roberto.eot": 9761,
	"./mighty-roberto.ttf": 6347,
	"./mighty-roberto.woff": 9449,
	"./mighty-roberto.woff2": 5993,
	"fonts/flat_2016/mighty-roberto.eot": 9761,
	"fonts/flat_2016/mighty-roberto.ttf": 6347,
	"fonts/flat_2016/mighty-roberto.woff": 9449,
	"fonts/flat_2016/mighty-roberto.woff2": 5993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8931;